﻿import '@ids-core/core';
import '@ids-core/alert-banner';
import '@ids-core/grid';
import '@ids-core/disclosure-card';
import '@ids-core/dropdown-select';
import '@ids-core/dropdown-filter';
import '../css/main.scss';

initComboboxes();

function initComboboxes() {
    const comboboxes = document.querySelectorAll('[role="combobox"]');
    comboboxes.forEach(combobox => {
        const listMenu = combobox.parentElement.querySelector('[role="menu"]');
        const list = combobox.parentElement.querySelector('[role="menu"] > ul');
        const filters = list.querySelectorAll('[role="menuitem"]');

        filters.forEach((filter) => {
            filter.addEventListener('click', () => applyFilter(filter));
            filter.parentElement.addEventListener('keydown', (e) => e.key === 'Enter' && applyFilter(filter));
        });

        function applyFilter(filterNode) {
            filters.forEach(f => f.setAttribute('aria-selected', false));
            filterNode.setAttribute('aria-selected', true);
            const filterValue = filterNode.getAttribute('id');
            list.setAttribute(
                'aria-activedescendant',
                filterValue
            );
            combobox.innerText = filterValue;
            setUrlState(filterNode.dataset.propertyName, filterValue);
            localStorage.setItem('login-page-selected-country', filterNode.getAttribute('data-country-code'));

            const controlsAttribute = filterNode.getAttribute('aria-controls');
            if (controlsAttribute) {
                const controlSelectors = [];
                filters.forEach(f => {
                    f.setAttribute('aria-expanded', false);
                    controlSelectors.push(`#${f.getAttribute('aria-controls')}`);
                });
                document
                    .querySelectorAll(controlSelectors.join(','))
                    .forEach(controlNode =>
                        controlNode.classList.add('hidden'));
                document
                    .querySelectorAll(`#${controlsAttribute}`)
                    .forEach(controlNode =>
                        controlNode.classList.remove('hidden'));
                filterNode.setAttribute('aria-expanded', true);
            }
            closeCountryCodeWindow();
        }

        function closeCountryCodeWindow() {
            listMenu.classList.remove('is-open');
            listMenu.classList.remove('is-active');
            combobox.setAttribute('aria-expanded', 'false');
        }

        function setUrlState(propertyName, value) {
            const url = new URL(window.location);
            url.searchParams.set(propertyName, value);
            window.history.pushState(null, '', url.toString());
        }
    });
}
